(function () {
  function slugify(text) {
    return text
      .toString()
      .trim()
      .toLowerCase()
      .replace(/&/g, ' and ')
      .replace(/[^a-z0-9\s-]/g, '')
      .replace(/\s+/g, '-')
      .replace(/-+/g, '-')
      .replace(/^-|-$/g, '') || 'section';
  }

  function enhanceContent(root) {
    root.querySelectorAll('table').forEach(function (table) {
      if (table.parentElement && table.parentElement.classList.contains('seo-blog__table-wrap')) return;
      var wrapper = document.createElement('div');
      wrapper.className = 'seo-blog__table-wrap';
      table.parentNode.insertBefore(wrapper, table);
      wrapper.appendChild(table);
    });

    root.querySelectorAll('iframe, video, embed').forEach(function (media) {
      if (media.parentElement && media.parentElement.classList.contains('seo-blog__media-wrap')) return;
      var wrapper = document.createElement('div');
      wrapper.className = 'seo-blog__media-wrap';
      media.parentNode.insertBefore(wrapper, media);
      wrapper.appendChild(media);
    });

    root.querySelectorAll('img').forEach(function (image) {
      if (!image.hasAttribute('loading')) image.setAttribute('loading', 'lazy');
      image.style.maxWidth = '100%';
      image.style.height = 'auto';
    });

    root.querySelectorAll('a[href]').forEach(function (link) {
      var href = link.getAttribute('href');
      if (!href || href.charAt(0) === '#' || href.charAt(0) === '/') return;
      try {
        var url = new URL(href, window.location.href);
        if (url.hostname !== window.location.hostname && link.target === '_blank') {
          var rel = new Set((link.getAttribute('rel') || '').split(/\s+/).filter(Boolean));
          rel.add('noopener');
          rel.add('noreferrer');
          link.setAttribute('rel', Array.from(rel).join(' '));
        }
      } catch (error) {}
    });
  }

  function buildToc(section) {
    var content = section.querySelector('[data-seo-blog-content]');
    var toc = section.querySelector('[data-seo-blog-toc]');
    if (!content || !toc) return;

    var headings = Array.from(content.querySelectorAll('h2, h3')).filter(function (heading) {
      return heading.textContent.trim().length > 0;
    });

    if (headings.length < 3) {
      toc.hidden = true;
      return;
    }

    var usedIds = {};
    var links = headings.map(function (heading) {
      var base = heading.id ? heading.id : slugify(heading.textContent);
      var id = base;
      var index = 2;
      while (usedIds[id] || document.getElementById(id) && document.getElementById(id) !== heading) {
        id = base + '-' + index;
        index += 1;
      }
      usedIds[id] = true;
      heading.id = id;

      var link = document.createElement('a');
      link.href = '#' + id;
      link.textContent = heading.textContent.trim();
      link.dataset.level = heading.tagName === 'H3' ? '3' : '2';
      return link;
    });

    var mobileTarget = toc.querySelector('[data-seo-blog-toc-list]');
    var desktopTarget = toc.querySelector('[data-seo-blog-toc-list-desktop]');
    links.forEach(function (link) {
      mobileTarget.appendChild(link.cloneNode(true));
      desktopTarget.appendChild(link);
    });

    toc.hidden = false;

    if ('IntersectionObserver' in window) {
      var allLinks = Array.from(toc.querySelectorAll('a'));
      var observer = new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) {
          if (!entry.isIntersecting) return;
          allLinks.forEach(function (link) {
            link.classList.toggle('is-active', link.getAttribute('href') === '#' + entry.target.id);
          });
        });
      }, { rootMargin: '-20% 0px -70% 0px' });

      headings.forEach(function (heading) {
        observer.observe(heading);
      });
    }
  }

  function setupCopyButtons(section) {
    section.querySelectorAll('[data-seo-blog-copy]').forEach(function (button) {
      button.addEventListener('click', function () {
        var url = button.getAttribute('data-seo-blog-copy') || window.location.href;
        if (!navigator.clipboard) return;
        navigator.clipboard.writeText(url).then(function () {
          var originalText = button.textContent;
          button.textContent = 'Copied';
          window.setTimeout(function () {
            button.textContent = originalText;
          }, 1800);
        });
      });
    });
  }

  document.addEventListener('DOMContentLoaded', function () {
    document.querySelectorAll('.seo-blog').forEach(function (section) {
      var content = section.querySelector('[data-seo-blog-content]');
      if (content) enhanceContent(content);
      buildToc(section);
      setupCopyButtons(section);
    });
  });
})();
